"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockRenderMapForSameWrapperAsUnorderedListItem = exports.WRAPPER = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _constants = require("./constants");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

// https://github.com/facebook/draft-js/blob/0.10-stable/src/model/immutable/DefaultDraftBlockRenderMap.js#L22
// <ul className={cx('public/DraftStyleDefault/ul')} />
var WRAPPER = _react["default"].createElement("ul", {
  className: "public-DraftStyleDefault-ul"
});

exports.WRAPPER = WRAPPER;
var blockRenderMap = (0, _immutable.Map)(_defineProperty({}, _constants.CHECKABLE_LIST_ITEM, {
  element: 'li',
  wrapper: WRAPPER
}));
var blockRenderMapForSameWrapperAsUnorderedListItem = blockRenderMap.merge((0, _immutable.Map)(_defineProperty({}, _constants.UNORDERED_LIST_ITEM, {
  element: 'li',
  wrapper: WRAPPER
})));
exports.blockRenderMapForSameWrapperAsUnorderedListItem = blockRenderMapForSameWrapperAsUnorderedListItem;
var _default = blockRenderMap;
exports["default"] = _default;